import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_FIELD } from '_constants';

const DashboardUI = ({ ...props }) => {
  DashboardUI.propTypes = {
    responseScores: PropTypes.array,
    scoreCount: PropTypes.number,
    activeReferralsCount: PropTypes.number,
    closedReferralsCount: PropTypes.number,
    percentage: PropTypes.number,
    firstColor: PropTypes.string,
    secondColor: PropTypes.string,
    toggleModal: PropTypes.func.isRequired,
    contactStrokeValue: PropTypes.func,
    navigateToReferral: PropTypes.func,
    dashboard: PropTypes.shape({
      dashArray: PropTypes.number.isRequired,
      radius: PropTypes.number.isRequired,
      scoreCount: PropTypes.number.isRequired,
      sqSize: PropTypes.number.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      viewBox: PropTypes.string.isRequired
    })
  };

  const { viewBox, strokeWidth } = props.dashboard;
  const sqSize = parseInt(props.dashboard.sqSize / 2) || 0;
  const radius = parseInt(props.dashboard.radius) || 0;
  // const strokeVal = props.contactStrokeValue(props.percentage);
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - dashArray * props.scoreCount / 100;

  return <React.Fragment>
    <div className='score-section'>
      <div className='score-title'>
        <span className='font-weight-bold'>RESPONSIVE SCORE</span>
        {props.responseScores &&
          <div className='score-history-icon'>
            <i
              className='material-icons material-icons-info font-size-20'
              aria-hidden='true'
              onClick={props.toggleModal}
            />
          </div>
        }
      </div>

      <div className='graph'>
        <svg

          viewBox={viewBox}>
          <defs>
            <linearGradient id='grad'>
              <stop offset='10%' stopColor={props.firstColor} />
              <stop offset='80%' stopColor={props.secondColor} />
            </linearGradient>
          </defs>
          <circle
            className='circle-background'
            cx={sqSize}
            cy={sqSize}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
          />
          <circle
            className='circle-background'
            cx={sqSize}
            cy={sqSize}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            transform={`rotate(-90 ${sqSize} ${sqSize})`}
            style={{
              stroke: 'url(#grad)',
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset
            }}
          />
          <text
            className='circle-text counter-anim'
            x='50%'
            y='50%'
            dy='.3em'
            textAnchor='middle'>
            {props.scoreCount}
          </text>
        </svg>
      </div>
      <div className='divider'>
        <svg width='100%' height='175%' viewBox='0 0 375 19' version='1.1' >
          <title>Curved Line</title>
          <desc>Created with Sketch.</desc>
          <defs>
            <linearGradient x1='0%' y1='100%' x2='100%' y2='100%' id='linearGradient-1'>
              <stop stopColor='#F4F4F4' offset='0%' />
              <stop stopColor='#B5B5B5' offset='50.1333333%' />
              <stop stopColor='#F4F4F4' offset='100%' />
            </linearGradient>
          </defs>
          <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <path d='M0,1 L121.8125,1 C123.3125,1.08333333 125.4375,1.54166667 128.1875,2.375 C132.3125,3.625 156.466742,18.0666667 187.5,18.0666667 C218.533258,18.0666667 238.61698,5.60250676 245.25,3.375 C249.672013,1.8899955 253.27618,1.09832883 256.0625,1 L375,1'
              id='Curved-Line' stroke='url(#linearGradient-1)' style={{
                stroke: 'url(#linearGradient-1)'
              }} strokeWidth='0.75' />
          </g>
        </svg>
      </div>
      <div className='duration-container'>
        Last <span>12 Months</span>
      </div>
    </div>
    <div className='stats-container'>
      <div className='stats-box' onClick={() => props.navigateToReferral(FILTER_FIELD.ACTIVE_REFERRAL)}>
        <h4>{props.activeReferralsCount}</h4>
        <div>ACTIVE</div>
        <div>REFERRALS</div>
      </div>
      <div className='stats-box' onClick={() => props.navigateToReferral(FILTER_FIELD.CLOSE_REFERRAL)}>
        <h4>{props.closedReferralsCount}</h4>
        <div>CLOSED</div>
        <div>REFERRALS</div>
      </div>
    </div>
  </React.Fragment>;
};

export default DashboardUI;
